import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

const notStaticPositionStyle = (theme, position) => ({
  // affect SecondaryNavigation with AppBar position
  '& + .MuiAppBar-root, & + .MuiDrawer-root + .MuiAppBar-root': {
    position: position,
    zIndex: theme.zIndex.appBar - 20,
    top: theme.mixins.toolbar.minHeight,
    left: '0',
    right: '0',
  },
});

export const flowAppBar: Components<Theme>['MuiAppBar'] = {
  defaultProps: {
    position: 'relative',
    elevation: 0,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      zIndex: theme.zIndex.appBar,
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.surface.primary : theme.palette.background.primary,
      color: theme.palette.text.primary,
      // also in Header in 'shortcuts' mobile section inside the drawer
      borderBottom: `1px solid ${theme.palette.mode === 'dark' ? theme.palette.onSurface.os700 : theme.palette.surface.secondary}`,
      [theme.breakpoints.up('xs')]: {
        minHeight: theme.mixins.toolbar.minHeight,
      },
      // containers inside
      '& .MuiContainer-root, & .MuiToolbar-root': {
        // take all space
        flexGrow: '1',
      },
    }),
    positionStatic: {
      // static position might break navigation inside, therefore it is same as relative
      position: 'relative',
    },
    positionFixed: ({ theme }) => notStaticPositionStyle(theme, 'fixed'),
    positionAbsolute: ({ theme }) => notStaticPositionStyle(theme, 'absolute'),
    positionSticky: ({ theme }) => notStaticPositionStyle(theme, 'sticky'),
  },
};
